import React, { useState, useEffect, Children } from 'react';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import './appointment.css';
import { FiAirplay } from "react-icons/fi";
import { IoMdStar } from "react-icons/io";
import Modal from 'react-bootstrap/Modal';
import { Link, Navigate } from 'react-router-dom';
import { Bookingsessiondetails, Getrating, showToast, handleInitiateStartsession, markOnTheWay } from '../Utils/utils'
import { useParams, useNavigate } from 'react-router-dom';
import Loader from '../../Component/Loader/Loader';
import moment from 'moment';
import { Initiatestartsession } from '../Redux/action/Initiatesession';
import { Initiatecompletesession } from '../Redux/action/Completedsession';
import { useDispatch } from 'react-redux';
import { FaPlay } from 'react-icons/fa';




const Appointmentdetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('time');
  const [show, setShow] = useState(false);
  const [sessiondata, Setsessiondata] = useState(null);
  const [loading, setLoading] = useState(false)
  const [showAudio, setShowAudio] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [error, setError] = useState(null);

  const [revew, setRevew] = useState([])
  const handleShow = () => setShow(true);


  const isValidId = (id) => /^[a-fA-F0-9]{24}$/.test(id);
  useEffect(() => {
    if (!id || !isValidId(id)) {
      navigate("/dashboard")
    }
  }, []);

  const handleBookingsesiondata = async () => {
    try {
      setLoading(true)
      const response = await Bookingsessiondetails(id);
      localStorage.setItem("sessionid", response?.data?._id);
      Setsessiondata(response?.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      handleBookingsesiondata()
    }
  }, [])


  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLat(position.coords.latitude);
        setLng(position.coords.longitude);
      },
      (error) => {
        setError(error.message);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  }, []);

  const Completesession = async () => {
    let session_id = sessiondata?.upcoming_slot?._id;
    try {
      setLoading(true);
      const response = await dispatch(Initiatecompletesession(session_id));
      showToast(response?.message, "success")
      handleClose()
      setTimeout(() => {
        window.location.href = `/completesession?id=${sessiondata?.upcoming_slot?._id}`;
      }, [1200])
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRevew = async () => {
    try {
      const response = await Getrating();
      setRevew(response?.data)
    } catch (error) {
      console.error(error, "get review error");
    }
  };
  useEffect(() => {
    handleRevew()
  }, [])





  const handleInitiate = async () => {
    if (!sessiondata?.upcoming_slot?._id) {
      showToast("Session ID not available. Please book a slot first", "error");
      return;
    }
    try {
      setLoading(true);
      const response = await dispatch(Initiatestartsession(sessiondata?.upcoming_slot?._id));
      setShow(false);
      setShow(response.message, "success");
      handleClose()
      if (response.status === 200) {
        window.location.href = `/startsession?id=${sessiondata?.upcoming_slot?._id}`;
      }
    } catch (error) {
      console.log(error, "error");
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false)
  }

  const opengoogleMap = (lat, long) => {
    window.open(`https://www.google.com/maps?q=${lat},${long}`, '_blank');
  }
  const markOntheway = async (id) => {
    try {
      const response = await markOnTheWay(id, lat, lng);
      if (response?.status == 200) {
        showToast(response?.message, "success")
        const ph = '+91' + response?.data?.phone_number;
        const message = `Hi ${response?.data?.name}, I am on the way to the destination to start the services.`
        const url = `https://wa.me/${ph}?text=${encodeURIComponent(message)}`;
        handleBookingsesiondata()
        setTimeout(() => {
          window.open(url, "_blank");
        }, 2500)

      }
    } catch (error) {
      console.log(error, "---EROR")
      showToast(error.message, "error");
    }
  };
  return (
    <>
      {loading && <Loader />}
      <div className="appoinment-top">
        <div className="booking-wrapper mx-auto">
          <div className="booking-top-container p-4">
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <img className="img-fluid" src="/Images/left-arrow.svg" alt="user-icon" />
            </Link>

            <span className="appoinment-title d-flex justify-content-center">Appointment Detail</span>
          </div>

          <div className="appoinment-details-info">

            <div className="d-flex align-items-center p-3">
              <span className="upcoming-schedule d-flex gap-1">
                {sessiondata?.date ? (
                  <span>{moment(sessiondata?.date).format("DD MMM")}</span>
                ) : (
                  "date not available"
                )}
                {sessiondata?.fromTime && sessiondata?.toTime ? (
                  <span>
                    {`${moment(sessiondata?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(sessiondata?.toTime, "HH:mm:ss").format("hh:mm A")}`}
                  </span>
                ) : (
                  "time not vailable"
                )}
              </span>


            </div>
            <div className="" style={{ borderBottom: "1.5px dashed #BEBEBE" }}></div>

            <div className="p-3">
              <div className="d-flex flex-column gap-1">
                <span className="user-details">{sessiondata?.member?.first_name} {sessiondata?.member?.last_name}</span>
                {/* <div className="d-flex gap-1 align-items-center">
                  <span className="user-common">29 years</span>
                  <span className="vertical-border"></span>
                  <span className="user-common">Female</span>
                </div> */}
                {/* <span className="user-address">View Location</span> */}
                <span className="user-address" style={{ fontSize: '13px', fontWeight: 400 }}>{sessiondata?.member?.address}</span>
                <span className="user-address" style={{ fontSize: '13px', fontWeight: 400, marginTop: '5px', color: '#7A7A7A', lineHeight: '17px' }}>{sessiondata?.booking?.description}</span>
              </div>
              <div className="d-flex gap-1 mt-3 row w-100 m-auto">
                <div
                  style={{ width: '120px', color: 'blue', cursor: 'pointer', paddingLeft: '0px' }}
                  className='pl-0'
                  onClick={() => opengoogleMap(sessiondata?.member?.latitude, sessiondata?.member?.longitude)}>
                  <span className="user-address" style={{ textDecoration: 'underline', fontSize: '12px' }}>View Location</span>
                </div>
                <div
                  onClick={() => {
                    setAudioUrl(sessiondata?.booking?.voice_note)
                    setShowAudio(!showAudio)
                  }}
                  className="audio-btn row">
                  <FaPlay size={"17px"} color='#fff' style={{ width: 'auto' }} />

                  <span style={{ fontSize: '12px', color: '#fff', fontFamily: 'Kumbh Sans', width: 'auto' }}>Play Voice Note</span>
                </div>
              </div>
              {
                (() => {
                  const fromTimeStr = sessiondata?.upcoming_slot?.fromTime;
                  if (fromTimeStr) {
                    const [hours, minutes] = fromTimeStr.split(':').map(Number);
                    const now = new Date();
                    const fromDate = new Date(
                      now.getFullYear(),
                      now.getMonth(),
                      now.getDate(),
                      hours,
                      minutes,
                      0
                    );
                    const diff = fromDate - now;
                    if ((diff <= 2 * 60 * 60 * 1000 && diff > 0) && sessiondata?.is_on_the_way == false) {
                      return (
                        <div className="d-flex gap-1 mt-3 row w-100 m-auto">
                          <div
                            style={{
                              border: '1px solid rgb(194, 38,39)',
                              backgroundColor: '#fff'
                            }}
                            onClick={() => {
                              markOntheway(sessiondata?._id)
                            }}
                            className="audio-btn row"
                          >
                            <span style={{ fontSize: '12px', color: 'rgb(194, 38,39)', fontFamily: 'Kumbh Sans', width: 'auto', fontWeight: 600 }}>
                              Mark On The Way
                            </span>
                          </div>
                        </div>
                      );
                    }
                  }
                  return null;
                })()
              }
            </div>

            <div className="tab-container p-3">
              <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={setActiveTab}>
                <Row className='d-flex flex-column'>

                  <Col sm={12} className="">
                    <Nav variant="" className="w-100 tab-option">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="time"
                          className={activeTab === 'time' ? 'active' : 'deactive'}
                        >
                          Time Slot
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="revew"
                          className={activeTab === 'revew' ? 'active' : 'deactive'}
                        >
                          Reviews
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane className='mb-5 mb-lg-0' eventKey="time">
                        <div className='time-conatiner w-[100] mt-3 p-3 d-flex flex-column gap-1'>
                          <span className='booking-id'>Booking ID - {sessiondata?.booking?.booking_number}</span>
                          <span className='slot'>Slot(s)</span>

                          {sessiondata && sessiondata?.booking_slots.length > 0 ?
                            sessiondata?.booking_slots?.map((item, index) => (
                              <div key={index} className="time-slot d-flex justify-content-between align-items-center mt-1">
                                <span className="time-slot-progress">
                                  {moment(item?.date).format("DD MMM YYYY")},{" "}
                                  {`${moment(item?.fromTime, "HH:mm:ss").format("hh:mm A")} - ${moment(item?.toTime, "HH:mm:ss").format("hh:mm A")}`}
                                </span>
                                {item.status === "assigned" ? (
                                  <div className="slot-progressbar-conatiner p-1">
                                    <span className="slot-progressbar">In Progress</span>
                                  </div>
                                ) : item.status === "completed" ? (
                                  <div className="slot-Completed-conatiner p-1">
                                    <span className="slot-complete-progressbar">Completed</span>
                                  </div>
                                ) : (
                                  <div className="slot-Onway-conatiner p-1">
                                    <span className="slot-Onway-progressbar">Ongoing</span>
                                  </div>
                                )}

                              </div>
                            )) : <>
                              <div className='d-flex justify-content-center align-items-center'><span className='not-available'>Booking slot not available</span></div>
                            </>}

                        </div>


                        {/* Notes conatiner */}
                        {sessiondata?.booking?.description != "" &&
                          <div className='time-conatiner w-[100] mt-3 p-3 d-flex flex-column gap-1 '>
                            <span className='notes-title'>Notes</span>
                            <span className='notes-detail'>{sessiondata?.booking?.description}. </span>
                          </div>
                        }
                        {/* close here */}
                      </Tab.Pane>
                      <Tab.Pane eventKey="revew" className='mb-5 mb-lg-0'>
                        <div className='revew-container w-[100] mt-3 d-flex flex-column gap-1'>
                          <div className='rating-section'>
                            <div>
                              <div className='d-flex align-items-center gap-3'>
                                <div>
                                  <span className='rating-left'>{revew?.average_rating ? revew?.average_rating : "0"}/</span>
                                  <span className={revew?.total_rating === 5 ? "rating-left" : "rating-right"}>5</span>
                                </div>

                                <div className='star-rating d-flex gap-1'>
                                  {Array.from({ length: 5 }).map((_, index) => (
                                    <IoMdStar key={index} size={"20px"} color={index < revew?.average_rating || revew?.average_rating === 5 ? "#FFBA33" : "#CBCBCB"} />
                                  ))}
                                </div>
                              </div>
                              <div className='number-review'>Based on {revew?.total_reviews
                                ? revew?.total_reviews
                                : "0"} reviews</div>
                            </div>
                            {revew && revew?.ratings?.length > 0 ?
                              revew?.ratings?.map((item, index) => (
                                <div className='review-box'>
                                  <div className='row justify-space'>
                                    <div className='width-auto' style={{ fontSize: '14px', color: '#000', fontFamily: 'Kumbh Sans', fontWeight: 500 }}>{item?.user?.full_name}</div>
                                    <div className='width-auto' style={{ fontSize: '14px', color: '#000', fontFamily: 'Kumbh Sans', fontWeight: 500 }}>{moment(item?.createdAt).format('DD MMM')}</div>
                                  </div>
                                  <div style={{ marginTop: '10px', fontSize: '12px', color: '#000', fontFamily: 'Kumbh Sans', fontWeight: 500 }}>
                                    {item?.review}
                                  </div>
                                  <div className='star-rating d-flex gap-1 mt-1'>
                                    {Array.from({ length: 5 }).map((_, index) => (
                                      <IoMdStar key={index} size={"20px"} color={index < item?.rating || item?.rating === 5 ? "#FFBA33" : "#CBCBCB"} />
                                    ))}
                                  </div>
                                  <div className='border-btm' />
                                  <div className='row w-100 p-0 mb-1' style={{ margin: 'auto' }} >
                                    <div className='col-6 p-0' style={{ display: 'flex', alignItems: 'center' }}>
                                      <div style={{ fontSize: '14px', color: '#000', fontFamily: 'Kumbh Sans', fontWeight: 400 }}>Provider’s behavior</div>
                                    </div>
                                    <div className='col-6 p-0' style={{ justifyContent: 'end', display: 'flex' }}>
                                      {item?.politeness == 5 ?
                                        <img src="/images/reaction1.png" className='react-img' />
                                        : item?.politeness == 4 ?
                                          <img src="/images/reaction4.png" className='react-img' />
                                          : item?.politeness == 3 ?
                                            <img src="/images/reaction3.png" className='react-img' />
                                            : item?.politeness == 2 ?
                                              <img src="/images/reaction2.png" className='react-img' />
                                              :
                                              <img src="/images/reaction5.png" className='react-img' />
                                      }
                                    </div>
                                  </div>
                                  <div className='row w-100 p-0 mb-1' style={{ margin: 'auto' }} >
                                    <div className='col-6 p-0'>
                                      <div style={{ fontSize: '14px', color: '#000', fontFamily: 'Kumbh Sans', fontWeight: 400 }}>Time Management</div>
                                    </div>
                                    <div className='col-6 p-0' style={{ justifyContent: 'end', display: 'flex' }}>
                                      {Array.from({ length: 5 }).map((_, index) => (
                                        <IoMdStar key={index} size={"20px"} color={index < item?.time_management || item?.time_management === 5 ? "#5A5A5A" : "#D9D9D9"} />
                                      ))}
                                    </div>
                                  </div>
                                  <div className='row w-100 p-0 mb-1' style={{ margin: 'auto' }} >
                                    <div className='col-6 p-0'>
                                      <div style={{ fontSize: '14px', color: '#000', fontFamily: 'Kumbh Sans', fontWeight: 400 }}>Skill Level</div>
                                    </div>
                                    <div className='col-6 p-0' style={{ justifyContent: 'end', display: 'flex' }}>
                                      {Array.from({ length: 5 }).map((_, index) => (
                                        <IoMdStar key={index} size={"20px"} color={index < item?.skills || item?.skills === 5 ? "#5A5A5A" : "#D9D9D9"} />
                                      ))}
                                    </div>
                                  </div>

                                </div>
                              )) :
                              <>
                                <div className='user-feedback w-[100] mt-2'>
                                  <div className='p-4'><span className='not-available d-flex justify-content-center align-items-center'>Review not available here</span></div>
                                </div>

                              </>
                            }


                            {/* {revew && revew?.ratings?.length > 0 ?
                              revew?.ratings?.map((item, index) => (
                                <div className='user-feedback w-[100] mt-2'>
                                  <div key={index} className='user-feedback-section p-3'>
                                    <span className='name'>{item?.user?.full_name}</span>
                                    <div className='d-flex align-items-center gap-1'>
                                      <div>
                                        <span className='rating-left'>{item?.rating ? item?.rating : "0"}/</span>
                                        <span className={revew?.rating === 5 ? "rating-left" : "rating-right"}>5</span>
                                      </div>
                                      <div className='star-rating d-flex gap-1'>
                                        {Array.from({ length: 5 }).map((_, i) => (
                                          <IoMdStar
                                            key={i}
                                            size={"20px"}
                                            color={
                                              i < (item?.rating || 0) ? "#FFBA33" : "#CBCBCB"
                                            }
                                          />
                                        ))}
                                      </div>
                                    </div>
                                    <span className='feedback-detail'>{item?.review || "No feedback provided"}</span>
                                  </div>
                                </div>
                              )) :
                              <>
                                <div className='user-feedback w-[100] mt-2'>
                                  <div className='p-4'><span className='not-available d-flex justify-content-center align-items-center'>Review not available here</span></div>
                                </div>

                              </>
                            } */}
                          </div>

                        </div>

                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
            {sessiondata?.upcoming_slot?.status && sessiondata?.upcoming_slot?.status !== "completed" &&
              <div className="btn-conatiner d-block d-lg-none d-md-none">
                {sessiondata?.upcoming_slot?.status === "ongoing" ? (
                  <button
                    className="submit-btn-res"
                    type="submit"
                    onClick={handleShow}
                  >
                    <span className="submit-btn-text">End Session</span>
                  </button>
                ) : sessiondata?.upcoming_slot?.status === "assigned" ? (
                  <button
                    className="submit-btn-res"
                    type="submit"
                    onClick={handleShow}
                  >
                    <span className="submit-btn-text">Start Session</span>
                  </button>
                ) : sessiondata?.upcoming_slot?.status === "completed" ? (
                  null
                ) : null}
              </div>
            }



            <div className='btn-conatiner-lg d-none d-lg-block d-md-block p-3' onClick={handleShow}>
              {sessiondata?.upcoming_slot?.status === "ongoing" ? (
                <button
                  className="submit-btn-lg"
                  type="button"
                  onClick={handleShow}
                >
                  <span className="submit-btn-text">End Session</span>
                </button>
              ) : sessiondata?.upcoming_slot?.status === "assigned" ? (
                <button
                  className="submit-btn-lg"
                  type="submit"
                  onClick={handleShow}
                >
                  <span className="submit-btn-text">Start Session</span>
                </button>
              ) : sessiondata?.upcoming_slot?.status === "completed" ? (
                null
              ) : null}
            </div>

          </div>

          {/* start sesstion modal */}
          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            // onHide={sessiondata?.upcoming_slot?.status === "ongoing" ? Completesession : handleInitiate}
            onHide={handleClose}
          >
            <div onClick={handleClose}>
              <img className="position-absolute top-0 end-0 m-3 close-btn img-fluid" src="/Images/close.svg" />
            </div>

            <div className="p-3 modal-body mx-auto d-flex flex-column justify-content-center align-items-center">
              <span className="modal-title text-center">{sessiondata?.upcoming_slot?.status === "ongoing" ? "Are you sure you want to end the session?" : "Are you sure you want to start the session?"}</span>
              <button className="submit-session d-flex justify-content-center align-items-center mt-4" onClick={sessiondata?.upcoming_slot?.status === "ongoing" ? Completesession : handleInitiate}>
                <span className="submit-session-text">Yes</span>
              </button>
            </div>
          </Modal>

          <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showAudio} onHide={() => setShowAudio(!showAudio)}>

            <Modal.Body style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 10px' }}>
              <div onClick={() => setShowAudio(!showAudio)}>
                <img className="position-absolute top-0 end-0 m-3 close-btn img-fluid" src="/Images/close.svg" />
              </div>
              <audio controls>
                <source src={audioUrl} type="audio/mp3" />
                Your browser does not support the audio element.
              </audio>
            </Modal.Body>

          </Modal>
          {/* close start session modal */}
        </div>

      </div>
    </>

  );
};

export default Appointmentdetail;
